import { __assign, __rest } from "tslib";
import React, { Suspense, lazy, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '../ErrorBoundary';
import noop from '../utils/noop';
import retry from '../utils/webpack/chunkRetry';
var Editor = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "editor", webpackPrefetch: true */
        './DaEditorWrapper.container');
    });
});
export var LoadableDaEditorWrapper = function (_a) {
    var StaticComponent = _a.staticComponent, LoadingComponent = _a.loadingComponent, forceLoadOnMount = _a.forceLoadOnMount, _b = _a.onStaticComponentClick, onStaticComponentClick = _b === void 0 ? noop : _b, rest = __rest(_a, ["staticComponent", "loadingComponent", "forceLoadOnMount", "onStaticComponentClick"]);
    var t = useTranslation().t;
    var _c = useState(false), show = _c[0], setShow = _c[1];
    var _d = useState(false), mounted = _d[0], setMounted = _d[1];
    var staticWrapperRef = useRef(null);
    useEffect(function () {
        setMounted(true);
        // When something is dragged into the static wrapper, load the editor.
        // This is so we don't lose files dragged into lazy unloaded editors.
        var staticWrapperEl = staticWrapperRef.current;
        if (staticWrapperEl) {
            staticWrapperEl.addEventListener('dragenter', function () {
                setShow(true);
            });
        }
    }, []);
    var handleClick = function () {
        setShow(true);
        onStaticComponentClick();
    };
    if (!show && StaticComponent && !forceLoadOnMount) {
        return (React.createElement("div", { role: "button", "aria-label": t('commentbox.editor.trigger'), tabIndex: 0, onKeyDown: function (e) {
                if (e.key === 'Enter' || e.key === 'Space' || e.key === ' ') {
                    handleClick();
                    e.preventDefault();
                }
            }, onClick: handleClick, ref: staticWrapperRef }, React.createElement(StaticComponent, null)));
    }
    var waitForMount = typeof window === 'undefined' && !mounted;
    if (!StaticComponent && waitForMount) {
        return null;
    }
    return (React.createElement(ErrorBoundary, { debugComponent: "LoadableDaEditorWrapper" },
        React.createElement(Suspense, { fallback: React.createElement(LoadingComponent, null) },
            React.createElement(Editor, __assign({}, rest)))));
};
LoadableDaEditorWrapper.displayName = 'LoadableDaEditorWrapper';
export default LoadableDaEditorWrapper;
//# sourceMappingURL=LoadableDaEditorWrapper.js.map